import React, { useState, useEffect } from 'react';
import { Menu, X, ChevronRight, ChevronLeft, Factory,Ship, Utensils, Pickaxe, HardHat, Shield, Truck, Award, Phone, Mail, MapPin, ArrowRight, Handshake, CheckCircle, Zap, Globe, Eye, Download, MessageCircle, Facebook, Instagram, Linkedin } from 'lucide-react';


const products = [
  {
    id: 1,
    name: "Ball Lock Stainless Steel Cable Ties",
    category: "Cable Ties",
    image: "/stainlesss steel.svg",
    shortDesc: "Premium Stainless Steel Ball-Lock Cable Ties for fast, secure installation",
    longDesc: [
  "Reliable roller-ball locking mechanism for fast, secure, self-locking installation.",
  "Can be tightened manually or with a compatible tensioning tool.",
  "Powder-coated variants offer enhanced resistance to abrasion, moisture, and corrosive environments—ideal for offshore and outdoor use.",
  "Uncoated stainless steel version recommended for high-temperature applications.",
  "Made from SS304 for standard use and SS316 marine grade for superior corrosion resistance.",
  "Suitable for petrochemical plants, food processing industries, power stations, mining, shipbuilding, offshore structures, and other hazardous environments."
],
    specs: [
  "SS304 / SS316 Marine Grade Stainless Steel",
  "Fireproof and Highly Corrosion Resistant",
  "Excellent Temperature Resistance",
  "High Vibration Resistance",

  // Operating Temperatures
  "Operating Temperature (Uncoated): -40°C to +300°C",
  "Operating Temperature (Coated): -60°C to +165°C",

  // Tensile Strengths
  "Tensile Strength (4.6 mm Uncoated): 120 lbs",
  "Tensile Strength (4.6 mm Coated): 100 lbs",
  "Tensile Strength (7.9 mm Uncoated): 250 lbs",
  "Tensile Strength (7.9 mm Coated): 230 lbs"
],

    type: "balllock"
  },
  {
    id: 2,
    name: "Ladder Type Stainless Steel Cable Ties",
    category: "Cable Ties",
    image: "/ladder type.svg",
    shortDesc: "Durable Ladder Type Ties for Industrial use",
    longDesc: [
  "Self-locking ladder design ensures quick, easy, and secure installation.",
  "Strong locking mechanism delivers reliable holding strength without crimping or folding.",
  "Low-profile, smooth head design prevents sharp edges and enables effortless installation.",
  "Tool compatibility allows increased locking tension where required.",
  "Coated variants provide enhanced protection against corrosion, chemicals, and harsh weather conditions.",
  "Uncoated stainless steel version is recommended for high-temperature environments.",
  "Extended usable length (slots up to the tail end) enables larger bundle diameters with the same tie length.",
  "Final slot allows use of hook-type tools for simplified tightening.",
  "Made from SS304 for standard applications and SS316 marine grade for superior corrosion resistance.",
  "Ideal for cable and pipe installation in extreme and hazardous environments including petrochemical plants, food processing facilities, power stations, mining sites, shipbuilding, offshore platforms, and other aggressive conditions."
],

    specs: [
  "SS304 / SS316 Marine Grade Stainless Steel",
  "Secure Ladder-Style Locking System",

  // Operating Temperatures
  "Operating Temperature (Uncoated): -40°C to +300°C",
  "Operating Temperature (Coated): -60°C to +165°C",

  // Tensile Strengths
  "Tensile Strength (7 mm Uncoated): 100 lbs",
  "Tensile Strength (7 mm Coated): 100 lbs",
  "Tensile Strength (12 mm Uncoated): 200 lbs",
  "Tensile Strength (12 mm Coated): 200 lbs",

  "Corrosion, chemical, and weather resistant",
  "Tool-assisted tensioning option available"
],
 type: "ladder"
  },
  {
    id: 3,
    name: "Stainless Steel Releasable Cable Ties",
    category: "Cable Ties",
    image: "/releasable.svg",
    shortDesc: "Releasable steel ties for adjustable and repeat-use applications",
    longDesc: [
  "Releasable design allows fastening, unfastening, and refastening for maximum flexibility.",
  "Ideal for temporary or adjustable installations due to reusability.",
  "Coated variants provide enhanced resistance to corrosion, radiation, and abrasion.",
  "Uncoated and coated options offer protection suitable for various environmental conditions.",
  "Manufactured from SS304 for standard use and SS316 marine grade for superior corrosion durability.",
  "Fully coated versions provide additional electrical insulation between dissimilar materials and protect cables and installer’s hands.",
  "Ensures fast, easy, and reliable installation with a secure release mechanism.",
  "Suitable for cable and pipe installations in extreme indoor and outdoor environments including petrochemical plants, food processing industries, power stations, mining operations, shipbuilding, offshore platforms, and other aggressive locations."
],
    specs: [
  "SS304 / SS316 Marine Grade Stainless Steel",
  "Releasable and Reusable Locking System",

  // Operating Temperatures
  "Operating Temperature (Uncoated): -40°C to +300°C",
  "Operating Temperature (Coated): -60°C to +165°C",

  // Tensile Strengths
  "Tensile Strength (5 mm Uncoated): 350 lbs",
  "Tensile Strength (5 mm Coated): 300 lbs",
  "Tensile Strength (10 mm Uncoated): 450 lbs",
  "Tensile Strength (10 mm Coated): 450 lbs",

  "Excellent resistance to corrosion, chemicals, and harsh environments",
  "Coated options offer enhanced abrasion and weather resistance"
],
   type: "releasable"
  },
  {
    id: 4,
    name: "Stainless Steel Bands",
    category: "Bands",
    image: "/bands.svg",
    shortDesc: "Durable Stainless Steel bands designed for heavy-duty clamping and bundling.",
    longDesc: [
  "Ideal for securing signs, air-conditioning units, large ducts, and industrial piping.",
  "Available in uncoated and powder-coated variants to suit standard and harsh-environment applications.",
  "Powder-coated bands offer enhanced resistance to corrosion, abrasion, and weathering.",
  "Easy-handling installation tools available for fast, safe, and efficient tensioning.",
  "Made from high-grade stainless steel to provide long-term mechanical strength and chemical durability.",
  "Corrosion-resistant SS316 (marine grade) provides superior performance in offshore and aggressive conditions.",
  "Powder-coated variants offer added protection for cables and installer’s hands, while reducing metal-to-metal contact between dissimilar surfaces.",
  "Flexible and cost-effective: 25-metre reels allow custom-length usage with minimal material waste.",
  "Suitable for securing components in outdoor, industrial, petrochemical, shipbuilding, and other demanding environments."
],
    specs: [
  "Durable Construction",
  "High Corrosion Resistance",

  "Material: Stainless Steel Grade SS304, SS316 & SS201",
  "Sizes: 6.3 mm (1/4”), 9.5 mm (3/8”), 12.7 mm (1/2”), 15.88 mm (5/8”), 19.01 mm (3/4”)",
  "Lengths: Custom lengths available as per customer requirement",

  "Type: Uncoated & Powder-Coated Bands",
  "Corrosion-resistant 316 grade steel for high mechanical and chemical durability",
  "Powder-coated versions offer improved protection and insulation",
  "25-metre reels allow flexible, cost-efficient installations with minimal waste"
],
    type: "bands"
  },
  {
    id: 5,
    name: "Stainless Steel Markers and Tags",
    category: "Markers & Tags",
    image: "/markers&tags.svg",
    shortDesc: "Reliable stainless steel markers and tags for secure equipment labeling.",
    longDesc: [
  "Comprehensive stainless steel marking system designed for permanent identification of cables, pipes, and ducting systems.",
  "Suitable for harsh industrial environments where long-term readability is essential.",
  "Compatible with both Roller Ball and Ladder Type Stainless Steel Cable Ties.",
  "Custom-marked Roller Ball type ties can be supplied upon request for specialized identification needs.",
  "Features sleeves with pre-embossed characters including letters, digits, and various symbols.",
  "Raised embossing allows clear readability even when covered with dust, paint, grease, or dirt.",
  "Identification strips are available in 6, 10, or 16-sleeve configurations for flexible labeling.",
  "Sleeves and strips are manufactured from corrosion-resistant SS316 (marine grade) offering strong mechanical and chemical durability."
],
    specs: [
  "Permanent Marking",
  "Corrosion Resistant",
  "High Durability",
  "Easy Identification",

  "Material: SS316 / SS304 / SS201"
],
    type: "tags"
  },
  {
    id: 6,
    name: "Hand Tool",
    category: "Tensioning and Cutting Tools",
    image: "/handtool.svg",
    shortDesc: "Reliable stainless steel hand tool for precise tensioning and cutting.",
    longDesc: [
  "Designed for precise tensioning and clean cutting of stainless steel cable ties.",
  "Ensures consistent, repeatable installation across various cable tie sizes.",
  "Ergonomic handle design reduces operator fatigue during prolonged use.",
  "Provides controlled tension to prevent over-tightening and potential damage to cables.",
  "Durable, industrial-grade construction suitable for harsh environments.",
  "Ideal for field installations, maintenance work, and repetitive fastening tasks."
],
    specs: [
  "Ergonomic Grip",
  "Precision Tensioning",
  "Clean Cutting",

  "Compatible with Stainless Steel Cable Ties",
  "Designed for repetitive industrial use",
  "Improves installation speed and accuracy",
  "Reduces hand fatigue during continuous operation"
],
   type: "tools"
  },
  {
    id: 7,
    name: "Ratchet Type",
    category: "Tensioning and Cutting Tools",
    image: "/ratchet.svg",
    shortDesc: "Industrial ratchet tool offering strong grip and smooth operation",
    longDesc: [
  "Heavy-duty ratchet mechanism ensures strong, controlled tensioning of stainless steel cable ties.",
  "Provides higher mechanical advantage for effortless tightening, even on large bundle diameters.",
  "Built for fast-paced industrial environments requiring reliable and repeatable fastening.",
  "Delivers uniform tension, reducing the chance of tie slippage or improper locking.",
  "Rugged steel body delivers long-term performance in harsh and corrosive environments.",
  "Ideal for petrochemical, offshore, electrical, and heavy mechanical applications."
],
    specs: [
  "High Leverage",
  "Durable Build",
  "Smooth Ratchet Action",

  "Suitable for large and heavy-duty cable ties",
  "Provides consistent and secure tensioning",
  "Increases installation efficiency and safety",
  "Ideal for demanding industrial applications"
],
    type: "tools"
  }
];

// ===================== SPEC DATA =======================

const ball46 = [
  { part: "MAX46UC100", partco:"MAX46CT100",  width: "4.6", length: "100", bundle: "20"},
  { part: "MAX46UC150", partco: "MAX46CT150", width: "4.6", length: "150", bundle: "35"},
  { part: "MAX46UC200", partco: "MAX46CT200", width: "4.6", length: "200", bundle: "50"},
  { part: "MAX46UC260", partco: "MAX46CT260", width: "4.6", length: "260", bundle: "70"},
  { part: "MAX46UC300", partco: "MAX46CT300", width: "4.6", length: "300", bundle: "85"},
  { part: "MAX46UC360", partco: "MAX46CT360", width: "4.6", length: "360", bundle: "100"},
  { part: "MAX46UC450", partco: "MAX46CT450",width: "4.6", length: "450", bundle: "132"},
  { part: "MAX46UC520", partco: "MAX46CT520", width: "4.6", length: "520", bundle: "158"},
  { part: "MAX46UC680", partco: "MAX46CT680", width: "4.6", length: "680", bundle: "189"},
  { part: "MAX46UC840", partco: "MAX46CT840", width: "4.6", length: "840", bundle: "260"},
  { part: "MAX46UC1000",partco: "MAX46CT1000", width: "4.6", length: "1000", bundle: "310"},
  { part: "MAX46UC1200", partco: "MAX46CT1200", width: "4.6", length: "1200", bundle: "365"},
  { part: "MAX46UC1300", partco: "MAX46CT1300", width: "4.6", length: "1300", bundle: "395"},
  { part: "MAX46UC1400", partco: "MAX46CT1400", width: "4.6", length: "1400", bundle: "425"},
  { part: "MAX46UC1500",partco: "MAX46CT1500", width: "4.6", length: "1600", bundle: "490"}
];

const ball79 = [
  { part:"MAX79UC100", partco:"MAX79CT100", width:"7.9", length:"100", bundle:"20"},
  { part:"MAX79UC150", partco:"MAX79CT150", width:"7.9", length:"150", bundle:"30"},
  { part:"MAX79UC200", partco:"MAX79CT200", width:"7.9", length:"200", bundle:"50"},
  { part:"MAX79UC250", partco:"MAX79CT250", width:"7.9", length:"250", bundle:"70"},
  { part:"MAX79UC300", partco:"MAX79CT300", width:"7.9", length:"300", bundle:"85"},
  { part:"MAX79UC360", partco:"MAX79CT360", width:"7.9", length:"360", bundle:"100"},
  { part:"MAX79UC450", partco:"MAX79CT450", width:"7.9", length:"450", bundle:"132"},
  { part:"MAX79UC520", partco:"MAX79CT520", width:"7.9", length:"520", bundle:"158"},
  { part:"MAX79UC680", partco:"MAX79CT680", width:"7.9", length:"680", bundle:"189"},
  { part:"MAX79UC840", partco:"MAX79CT840", width:"7.9", length:"840", bundle:"260"},
  { part:"MAX79UC1000", partco:"MAX79CT1000", width:"7.9", length:"1000", bundle:"310"},
  { part:"MAX79UC1200", partco:"MAX79CT1200", width:"7.9", length:"1200", bundle:"360"},
  { part:"MAX79UC1300", partco:"MAX79CT1300", width:"7.9", length:"1300", bundle:"395"},
  { part:"MAX79UC1400", partco:"MAX79CT1400", width:"7.9", length:"1400", bundle:"425"},
  { part:"MAX79UC1500", partco:"MAX79CT1500", width:"7.9", length:"1600", bundle:"490"}
];

const ball12 = [
 { part: "MAX12UC200", partco: "MAX12CT200", width: "12", length: "200", bundle: "50" },
 { part: "MAX12UC300", partco: "MAX12CT300", width: "12", length: "300", bundle: "83" },
 { part: "MAX12UC360", partco: "MAX12CT360", width: "12", length: "360", bundle: "100" },
 { part: "MAX12UC450", partco: "MAX12CT450", width: "12", length: "450", bundle: "130" },
 { part: "MAX12UC520", partco: "MAX12CT520", width: "12", length: "520", bundle: "150" },
 { part: "MAX12UC680", partco: "MAX12CT680", width: "12", length: "680", bundle: "200" },
 { part: "MAX12UC840", partco: "MAX12CT840", width: "12", length: "840", bundle: "250" },
 { part: "MAX12UC1000", partco: "MAX12CT1000", width: "12", length: "1000", bundle: "300" },
 { part: "MAX12UC1200", partco: "MAX12CT1200", width: "12", length: "1200", bundle: "365" },
 { part: "MAX12UC1400", partco: "MAX12CT1400", width: "12", length: "1400", bundle: "425" }
];

const ball16 = [
 { part: "MAX16UC200", partco: "MAX16CT200", width: "16", length: "200", bundle: "50" },
 { part: "MAX16UC300", partco: "MAX16CT300", width: "16", length: "300", bundle: "83" },
 { part: "MAX16UC360", partco: "MAX16CT360", width: "16", length: "360", bundle: "100" },
 { part: "MAX16UC450", partco: "MAX16CT450", width: "16", length: "450", bundle: "130" },
 { part: "MAX16UC520", partco: "MAX16CT520", width: "16", length: "520", bundle: "150" },
 { part: "MAX16UC680", partco: "MAX16CT680", width: "16", length: "680", bundle: "200" },
 { part: "MAX16UC840", partco: "MAX16CT840", width: "16", length: "840", bundle: "250" },
 { part: "MAX16UC1000", partco: "MAX16CT1000", width: "16", length: "1000", bundle: "300" },
 { part: "MAX16UC1200", partco: "MAX16CT1200", width: "16", length: "1200", bundle: "365" },
 { part: "MAX16UC1400", partco: "MAX16CT1400", width: "16", length: "1400", bundle: "425" }
];

const ballSpecs = {
  coated: [...ball46, ...ball79, ...ball12, ...ball16]
}

const ladder7 = [
 { part: "MAXLUC100", partco: "MAXLCT100", width: "7.0", length: "100", bundle: "25" },
 { part: "MAXLUC150", partco: "MAXLCT150", width: "7.0", length: "150", bundle: "45" },
 { part: "MAXLUC200", partco: "MAXLCT200", width: "7.0", length: "200", bundle: "60" },
 { part: "MAXLUC225", partco: "MAXLCT225", width: "7.0", length: "225", bundle: "70" },
 { part: "MAXLUC250", partco: "MAXLCT250", width: "7.0", length: "250", bundle: "80" },
 { part: "MAXLUC300", partco: "MAXLCT300", width: "7.0", length: "300", bundle: "95" },
 { part: "MAXLUC360", partco: "MAXLCT360", width: "7.0", length: "360", bundle: "105" },
 { part: "MAXLUC450", partco: "MAXLCT450", width: "7.0", length: "450", bundle: "140" },
 { part: "MAXLUC520", partco: "MAXLCT520", width: "7.0", length: "520", bundle: "160" },
 { part: "MAXLUC650", partco: "MAXLCT650", width: "7.0", length: "650", bundle: "200" },
 { part: "MAXLUC750", partco: "MAXLCT750", width: "7.0", length: "750", bundle: "235" },
 { part: "MAXLUC915", partco: "MAXLCT915", width: "7.0", length: "915", bundle: "280" },
 { part: "MAXLUC1000", partco: "MAXLCT1000", width: "7.0", length: "1000", bundle: "315" },
 { part: "MAXLUC1200", partco: "MAXLCT1200", width: "7.0", length: "1200", bundle: "375" },
 { part: "MAXLUC1400", partco: "MAXLCT1400", width: "7.0", length: "1400", bundle: "440" },
 { part: "MAXLUC1500", partco: "MAXLCT1500", width: "7.0", length: "1600", bundle: "500" }
];

const ladder12 = [
 { part: "MAXLUC100", partco: "MAXLCT100", width: "12", length: "100", bundle: "25" },
 { part: "MAXLUC150", partco: "MAXLCT150", width: "12", length: "150", bundle: "43" },
 { part: "MAXLUC200", partco: "MAXLCT200", width: "12", length: "200", bundle: "50" },
 { part: "MAXLUC225", partco: "MAXLCT225", width: "12", length: "225", bundle: "60" },
 { part: "MAXLUC250", partco: "MAXLCT250", width: "12", length: "250", bundle: "70" },
 { part: "MAXLUC300", partco: "MAXLCT300", width: "12", length: "300", bundle: "80" },
 { part: "MAXLUC360", partco: "MAXLCT360", width: "12", length: "360", bundle: "100" },
 { part: "MAXLUC450", partco: "MAXLCT450", width: "12", length: "450", bundle: "135" },
 { part: "MAXLUC610", partco: "MAXLCT610", width: "12", length: "610", bundle: "185" },
 { part: "MAXLUC1250", partco: "MAXLCT1250", width: "12", length: "750", bundle: "230" },
 { part: "MAXLUC915", partco: "MAXLCT915", width: "12", length: "915", bundle: "295" },
 { part: "MAXLUC1000", partco: "MAXLCT1000", width: "12", length: "1000", bundle: "310" },
 { part: "MAXLUC1200", partco: "MAXLCT1200", width: "12", length: "1200", bundle: "370" },
 { part: "MAXLUC1400", partco: "MAXLCT1400", width: "12", length: "1400", bundle: "425" },
 { part: "MAXLUC1500", partco: "MAXLCT1500", width: "12", length: "1600", bundle: "495" }
];

const ladderSpecs = { coated: [...ladder7, ...ladder12]};

const releasable5 = [
 { part: "MAXRUC150", partco: "MAXRCT150", width: "5", length: "150", bundle: "36"},
 { part: "MAXRUC230", partco: "MAXRCT230", width: "5", length: "230", bundle: "60"},
 { part: "MAXRUC300", partco: "MAXRCT300", width: "5", length: "300", bundle: "85"},
 { part: "MAXRUC330", partco: "MAXRCT330", width: "5", length: "330", bundle: "95"},
 { part: "MAXRUC450", partco: "MAXRCT450", width: "5", length: "450", bundle: "130"},
 { part: "MAXRUC610", partco: "MAXRCT610", width: "5", length: "610", bundle: "180"},
 { part: "MAXRUC650", partco: "MAXRCT650", width: "5", length: "650", bundle: "190"},
 { part: "MAXRUC760", partco: "MAXRCT760", width: "5", length: "760", bundle: "230"},
 { part: "MAXRUC840", partco: "MAXRCT840", width: "5", length: "840", bundle: "250"},
 { part: "MAXRUC910", partco: "MAXRCT910", width: "5", length: "910", bundle: "175"},
 { part: "MAXRUC1000", partco: "MAXRCT1000", width: "5", length: "1000", bundle: "300"},
 { part: "MAXRUC1400", partco: "MAXRCT1400", width: "5", length: "1400", bundle: "430"},
 { part: "MAXRUC1600", partco: "MAXRCT1600", width: "5", length: "1600", bundle: "500"}
];

const releasable10 = [
 { part: "MAXRUC150", partco: "MAXRCT150", width: "10", length: "150", bundle: "36" },
 { part: "MAXRUC230", partco: "MAXRCT230", width: "10", length: "230", bundle: "60" },
 { part: "MAXRUC300", partco: "MAXRCT300", width: "10", length: "300", bundle: "85" },
 { part: "MAXRUC330", partco: "MAXRCT330", width: "10", length: "330", bundle: "95" },
 { part: "MAXRUC610", partco: "MAXRCT610", width: "10", length: "450", bundle: "130" },
 { part: "MAXRUC650", partco: "MAXRCT650", width: "10", length: "610", bundle: "180" },
 { part: "MAXRUC760", partco: "MAXRCT760", width: "10", length: "650", bundle: "190" },
 { part: "MAXRUC840", partco: "MAXRCT840", width: "10", length: "760", bundle: "230" },
 { part: "MAXRUC910", partco: "MAXRCT910", width: "10", length: "840", bundle: "250" },
 { part: "MAXRUC1000", partco: "MAXRCT1000", width: "10", length: "910", bundle: "175" },
 { part: "MAXRUC1400", partco: "MAXRCT1400", width: "10", length: "1000", bundle: "300" },
 { part: "MAXRUC1600", partco: "MAXRCT1600", width: "10", length: "1400", bundle: "430" },
 { part: "MAXRUC450", partco: "MAXRCT450", width: "10", length: "1600", bundle: "500" }
];

const releasableSpecs = {
  coated: [...releasable5, ...releasable10]
};

const markers_tags = [
  {desc: "TAG", product_code: "MAX-3463", dimensions: "34*63"},
  {desc: "TAG", product_code: "MAX-1951", dimensions: "19*51"},
  {desc: "TAG", product_code: "MAX-1989", dimensions: "19*89"},
  {desc: "TAG", product_code: "MAX-1992", dimensions: "19*92"},
  {desc: "TAG", product_code: "MAX-892", dimensions: "8*92"},
  {desc: "TAG", product_code: "MAX-8133", dimensions: "8*133"},
  {desc: "TAG", product_code: "MAX-8166", dimensions: "8*166"},
  {desc: "ALPHABETS", product_code: "A-Z", dimensions: "8*9"},
  {desc: "NUMBERS", product_code: "0-9", dimensions: "8*9"},
  {desc: "SPECIAL CHARACTERS", product_code: "+,-,`,#,/, etc", dimensions: "8*9"}
]

const markers_tagsSpecs = {markers_tags}

const stats = [
  { num: '20+', label: 'Years Experience', icon: Award },
  { num: 'In-House', label: 'Manufacturing Unit', icon: Factory },
  { num: 'Trusted', label: 'Industrial Partner', icon: Handshake },
  { num: '5+', label: 'Countries Served', icon: Globe },
];

const whatsappNumber = "+91 8401452740";
const whatsappMessage = "Hi! I'm interested in your cable tie products.";

const socialLinks = {
  facebook: "https://facebook.com/tiepro",
  instagram: "https://instagram.com/tiepro",
  linkedin: "https://linkedin.com/company/tiepro"
};

// =========================================================================
// II. HELPER COMPONENTS (UPDATED PRODUCT CARD)
// =========================================================================

const ProductCard = ({ p, onClick }) => (
  <div className="group bg-gray-800 rounded-2xl overflow-hidden border border-gray-700 hover:border-emerald-500/50 transition-all duration-500 hover:-translate-y-2 flex-shrink-0 w-full md:w-72">
    <div className="h-48 bg-gradient-to-br from-gray-700 to-gray-800 flex items-center justify-center overflow-hidden">
      <img 
        src={p.image} 
        alt={p.name} 
        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
      />
    </div>

    <div className="p-6">
      <span className="text-xs text-emerald-400 font-medium">{p.category}</span>
      <h3 className="text-lg font-semibold text-white mt-1 mb-2">{p.name}</h3>
      <p className="text-gray-400 text-sm mb-4">{p.shortDesc}</p>

      <button 
        onClick={() => onClick(p)} 
        className="w-full py-3 bg-emerald-500/20 text-emerald-400 rounded-xl hover:bg-emerald-500 hover:text-white transition-all"
      >
        <span className="inline-flex items-center justify-center gap-2 w-full">
          <Eye size={18} /> 
          <span>{p.type === 'tools' ? 'View Details' : 'View Specifications'}</span>
        </span>
      </button>
    </div>
  </div>
);

// =========================================================================
// II. HELPER COMPONENTS (UPDATED SPECS MODAL WITH FIXED FILTER LOGIC)
// =========================================================================

const SpecsModal = ({ product, onClose, setPage }) => {
  const [activeTab, setActiveTab] = useState("size");
  const [selectedWidth, setSelectedWidth] = useState("");

  const SPEC_DATA = {
    balllock: [...ball46, ...ball79, ...ball12, ...ball16],
    ladder: [...ladder7, ...ladder12],
    releasable: [...releasable5, ...releasable10],
    tags: markers_tags.map(r => ({
      description: r.desc,
      product_code: r.product_code,
      dimensions: r.dimensions
    }))
  };

  const STATIC_WIDTHS = {
    balllock: ["All Sizes", "4.6 mm", "7.9 mm", "12 mm", "16 mm"],
    ladder: ["All Sizes", "7.0 mm", "12 mm and above"],
    releasable: ["All Sizes", "5 mm", "10 mm and above"]
  };

  const isTool = product.type === "tools" || product.type === "bands";

  const data = SPEC_DATA[product.type] || [];

  const getWidths = () => {
    if (!STATIC_WIDTHS[product.type]) return ["All Sizes"];
    return STATIC_WIDTHS[product.type];
  };

  const filteredData = () => {
    if (product.type === "tags") return data;
    if (selectedWidth === "" || selectedWidth === "All Sizes") return data;

    const num = parseFloat(selectedWidth);
    const isAbove = selectedWidth.includes("and above");

    return data.filter(item => {
      const w = parseFloat(item.width);
      if (isAbove) return w >= num;
      return w === num;
    });
  };

  useEffect(() => {
    const widths = getWidths();
    setSelectedWidth(widths[0]);
  }, [product]);

  const goToContact = () => {
    onClose();
    setTimeout(() => setPage("contact"), 10);
  };

  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center p-4 z-50" onClick={onClose}>
      <div
        className="bg-gray-800 w-full max-w-4xl rounded-2xl p-6 border border-gray-700 max-h-[90vh] overflow-y-auto"
        onClick={e => e.stopPropagation()}
      >
        {/* HEADER */}
        <div className="flex justify-between items-center border-b pb-4 border-gray-700">
          <h2 className="text-white text-2xl font-bold">{product.name}</h2>
          <button onClick={onClose}><X className="text-white" /></button>
        </div>

        {/* ============================================================
            TOOLS + BANDS → ONLY DESCRIPTION VIEW
        ============================================================ */}
        {isTool ? (
          <div className="mt-6">
            <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
              <Zap size={20} className="text-emerald-400" /> Key Features
            </h3>

            <div className="grid grid-cols-2 gap-4">
              {product.specs.map((s, i) => (
                <div key={i} className="flex items-center gap-2 px-3 py-3 bg-gray-700/50 rounded-lg text-sm text-gray-300">
                  <CheckCircle size={18} className="text-emerald-400" />
                  {s}
                </div>
              ))}
            </div>

            <ul className="text-gray-300 mt-6 border-top border-gray-700 pt-4 space-y-3 list-disc pl-6">
              {product.longDesc.map((point, i) => (
                <li key={i}>{point}</li>
              ))}
            </ul>

            {/* FIXED: Redirect Without Router */}
            <button
              onClick={goToContact}
              className="mt-8 w-full py-4 bg-gradient-to-r from-emerald-500 to-cyan-500 rounded-xl font-semibold text-white"
            >
              Request Quote
            </button>
          </div>
        ) : (
          <>
            {/* ============================================================
                NORMAL PRODUCTS → SIZE + DESCRIPTION TABS
            ============================================================ */}
            <div className="flex mt-4 mb-6 rounded-xl overflow-hidden">
              <button
                onClick={() => setActiveTab("size")}
                className={`w-1/2 py-3 font-bold transition-all ${
                  activeTab === "size"
                    ? "bg-emerald-500 text-white"
                    : "bg-gray-700 text-gray-300 hover:bg-gray-600"
                }`}
              >
                SIZE CHART
              </button>

              <button
                onClick={() => setActiveTab("desc")}
                className={`w-1/2 py-3 font-bold transition-all ${
                  activeTab === "desc"
                    ? "bg-emerald-500 text-white"
                    : "bg-gray-700 text-gray-300 hover:bg-gray-600"
                }`}
              >
                DESCRIPTION
              </button>
            </div>

            {/* ======================= SIZE TAB ======================= */}
            {activeTab === "size" && (
              <>
                {product.type !== "tags" && (
                  <div className="mb-6">
                    <label className="block text-sm font-medium text-gray-400 mb-2">
                      Filter by Width (mm):
                    </label>
                    <select
                      value={selectedWidth}
                      onChange={(e) => setSelectedWidth(e.target.value)}
                      className="w-full md:w-1/3 px-4 py-3 bg-gray-700 border border-gray-600 rounded-xl text-white"
                    >
                      {getWidths().map(w => (
                        <option key={w} value={w}>{w}</option>
                      ))}
                    </select>
                  </div>
                )}

                <div className="overflow-x-auto">
                  {product.type === "tags" ? (
                    <table className="w-full">
                      <thead>
                        <tr className="border-b border-gray-700 text-emerald-400">
                          <th className="p-3 text-left">DESCRIPTION</th>
                          <th className="p-3 text-left">PRODUCT CODE</th>
                          <th className="p-3 text-left">DIMENSIONS</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.map((row, i) => (
                          <tr key={i} className="border-b border-gray-700 text-gray-200 hover:bg-gray-700/30">
                            <td className="p-3">{row.description}</td>
                            <td className="p-3">{row.product_code}</td>
                            <td className="p-3">{row.dimensions}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <table className="w-full">
                      <thead>
                        <tr className="border-b border-gray-700 text-emerald-400">
                          <th className="p-3 text-left">PART CODE (UnCoated)</th>
                          <th className="p-3 text-left">PART CODE (Coated)</th>
                          <th className="p-3 text-left">WIDTH (mm)</th>
                          <th className="p-3 text-left">LENGTH (mm)</th>
                          <th className="p-3 text-left">BUNDLE DIA (mm)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredData().map((r, i) => (
                          <tr key={i} className="border-b border-gray-700 text-gray-200 hover:bg-gray-700/30">
                            <td className="p-3">{r.part}</td>
                            <td className="p-3">{r.partco}</td>
                            <td className="p-3">{r.width}</td>
                            <td className="p-3">{r.length}</td>
                            <td className="p-3">{r.bundle}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>

                <p className="text-gray-400 text-sm mt-4 italic">
                  Note: Intermediate length options are available upon customer requirement.
                </p>

                {/* FIXED: Redirect Without Router */}
                <button
                  onClick={goToContact}
                  className="mt-6 w-full py-4 bg-gradient-to-r from-emerald-500 to-cyan-500 rounded-xl font-semibold text-white"
                >
                  Request Quote
                </button>
              </>
            )}

            {/* ======================= DESCRIPTION TAB ======================= */}
            {activeTab === "desc" && (
              <div className="mt-6">
                <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
                  <Zap size={20} className="text-emerald-400" /> Product Description
                </h3>

                <ul className="text-gray-300 mb-6 space-y-3 list-disc pl-6">
                  {product.longDesc.map((point, i) => (
                    <li key={i}>{point}</li>
                  ))}
                </ul>

                <h4 className="text-white text-xl font-semibold mb-3">Key Features</h4>
                <div className="grid grid-cols-2 gap-4">
                  {product.specs.map((s, i) => (
                    <div key={i} className="flex items-center gap-2 px-3 py-3 bg-gray-700/50 rounded-lg text-sm text-gray-300">
                      <CheckCircle size={18} className="text-emerald-400" />
                      {s}
                    </div>
                  ))}
                </div>

                {/* FIXED: Redirect Without Router */}
                <button
                  onClick={goToContact}
                  className="mt-8 w-full py-4 bg-gradient-to-r from-emerald-500 to-cyan-500 rounded-xl font-semibold text-white"
                >
                  Request Quote
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};
// 🐛 FIXED: Added setSelectedProduct as a prop to pass down to ProductCard
const Carousel = ({ items, carouselIndex, setCarouselIndex, nextSlide, prevSlide, setSelectedProduct }) => (
  <div className="relative">
    <div className="overflow-hidden">
      <div className="flex gap-6 transition-transform duration-500 ease-out" style={{ transform: `translateX(-${carouselIndex * 288}px)` }}>
        {/* 🐛 FIX APPLIED: Passing setSelectedProduct to ProductCard via the onClick prop */}
        {items.map(p => <ProductCard key={p.id} p={p} onClick={setSelectedProduct} featured={false} />)}
      </div>
    </div>
    {items.length > 3 && (
      <>
        <button onClick={prevSlide} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 w-12 h-12 bg-gray-800 border border-gray-700 rounded-full flex items-center justify-center text-white hover:bg-emerald-500 hover:border-emerald-500 transition-all shadow-xl z-10">
          <ChevronLeft size={24} />
        </button>
        <button onClick={nextSlide} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 w-12 h-12 bg-gray-800 border border-gray-700 rounded-full flex items-center justify-center text-white hover:bg-emerald-500 hover:border-emerald-500 transition-all shadow-xl z-10">
          <ChevronRight size={24} />
        </button>
      </>
    )}
    <div className="flex justify-center gap-2 mt-8">
      {Array.from({ length: Math.max(1, items.length - 2) }).map((_, i) => (
        <button key={i} onClick={() => setCarouselIndex(i)} className={`w-2 h-2 rounded-full transition-all ${i === carouselIndex ? 'w-8 bg-emerald-500' : 'bg-gray-600 hover:bg-gray-500'}`} />
      ))}
    </div>
  </div>
);

const NavLink = ({ to, currentPage, setPage, setMenuOpen, children }) => (
  <button onClick={() => { setPage(to); setMenuOpen(false); }} className={`relative px-4 py-2 font-medium transition-all duration-300 ${currentPage === to ? 'text-emerald-400' : 'text-gray-300 hover:text-white'}`}>
    {children}
    <span className={`absolute bottom-0 left-0 h-0.5 bg-gradient-to-r from-emerald-400 to-cyan-400 transition-all duration-300 ${currentPage === to ? 'w-full' : 'w-0'}`} />
  </button>
);

const Header = ({ scrollY, page, setPage, menuOpen, setMenuOpen }) => (
  <header className={`fixed top-0 w-full z-40 transition-all duration-500 ${scrollY > 50 ? 'bg-gray-900/95 backdrop-blur-lg shadow-2xl' : 'bg-transparent'}`}>
    {/* 1. Changed 'justify-between' to 'justify-start' and increased gap.
      2. Set a maximum width and aligned to the left of the container.
    */}
    <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-start gap-12">
      
      {/* MAIN LOGO CONTAINER (CLEANED UP & SIZED UP)
        This is the single container that handles both the image and the text. 
      */}
      <div className="flex items-center gap-3 cursor-pointer" onClick={() => setPage('home')}>
        
        {/* IMAGE: Increased size from w-10/h-10 to w-12/h-12 */}
        <img 
          src="/MEW logo.png" 
          alt="Company Logo"
          className="w-20 h-20 object-contain" // w-12/h-12 for bigger logo
        />
        
        {/* TEXT: Increased size from text-2xl to text-3xl */}
        <span className="text-3xl font-bold bg-gradient-to-r from-emerald-400 to-cyan-400 bg-clip-text text-transparent">Max Cable Ties</span>
      </div>
      
      {/* NAVIGATION: Added 'ml-auto' to push the navigation links to the far right */}
      <nav className="hidden md:flex items-center gap-2 ml-auto"> 
        <NavLink to="home" currentPage={page} setPage={setPage} setMenuOpen={setMenuOpen}>Home</NavLink>
        <NavLink to="about" currentPage={page} setPage={setPage} setMenuOpen={setMenuOpen}>About Us</NavLink>
        <NavLink to="products" currentPage={page} setPage={setPage} setMenuOpen={setMenuOpen}>Products</NavLink>
        <NavLink to="contact" currentPage={page} setPage={setPage} setMenuOpen={setMenuOpen}>Contact</NavLink>
      </nav>
      
      {/* MENU BUTTON: Still on the far right, next to navigation */}
      <button onClick={() => setMenuOpen(!menuOpen)} className="md:hidden text-white p-2 ml-auto">{menuOpen ? <X size={24} /> : <Menu size={24} />}</button>
    </div>
    
    {menuOpen && (
      <div className="md:hidden bg-gray-900/98 backdrop-blur-lg border-t border-gray-800">
        <div className="flex flex-col p-4 gap-2">
          <NavLink to="home" currentPage={page} setPage={setPage} setMenuOpen={setMenuOpen}>Home</NavLink>
          <NavLink to="about" currentPage={page} setPage={setPage} setMenuOpen={setMenuOpen}>About Us</NavLink>
          <NavLink to="products" currentPage={page} setPage={setPage} setMenuOpen={setMenuOpen}>Products</NavLink>
          <NavLink to="contact" currentPage={page} setPage={setPage} setMenuOpen={setMenuOpen}>Contact</NavLink>
        </div>
      </div>
    )}
  </header>
);
const CatalogModal = ({ setShowCatalogModal }) => {
  const generatePDF = () => {
    const link = document.createElement("a");
    link.href = "/MAX CABLE TIES BROCHURE.pdf";
    link.download = "Max Brochure.pdf";
    link.click();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={() => setShowCatalogModal(false)}>
      <div className="bg-gray-800 rounded-3xl max-w-md w-full p-8 border border-gray-700 shadow-2xl" onClick={e => e.stopPropagation()}>
        <div className="text-center">
          <div className="w-20 h-20 bg-gradient-to-br from-emerald-500/20 to-cyan-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
            <Download className="text-emerald-400" size={40} />
          </div>
          <h2 className="text-2xl font-bold text-white mb-4">Download Product Catalog</h2>
          <p className="text-gray-400 mb-8">Get our complete product catalog with detailed specifications, pricing information, and technical details.</p>
          
          <div className="space-y-4 mb-8">
            <div className="flex items-center gap-3 text-gray-300 text-sm">
              <CheckCircle size={18} className="text-emerald-400 flex-shrink-0" />
              <span>Complete product specifications</span>
            </div>
            <div className="flex items-center gap-3 text-gray-300 text-sm">
              <CheckCircle size={18} className="text-emerald-400 flex-shrink-0" />
              <span>Technical data sheets</span>
            </div>
            <div className="flex items-center gap-3 text-gray-300 text-sm">
              <CheckCircle size={18} className="text-emerald-400 flex-shrink-0" />
              <span>Quality certifications</span>
            </div>
          </div>

          <button 
            onClick={generatePDF}
            className="w-full py-4 bg-gradient-to-r from-emerald-500 to-cyan-500 rounded-xl font-semibold text-white shadow-lg shadow-emerald-500/30 hover:shadow-emerald-500/50 transition-all duration-300 hover:-translate-y-1 flex items-center justify-center gap-2 mb-3"
          >
            <Download size={20} /> Download Catalog
          </button>
          
          <button 
            onClick={() => setShowCatalogModal(false)}
            className="w-full py-3 bg-gray-700 hover:bg-gray-600 rounded-xl font-medium text-white transition-all"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

const WhatsAppButton = () => (
  <a
    href={`https://wa.me/${whatsappNumber.replace(/[^0-9]/g, '')}?text=${encodeURIComponent(whatsappMessage)}`}
    target="_blank"
    rel="noopener noreferrer"
    className="fixed bottom-6 right-6 z-40 w-16 h-16 bg-green-500 hover:bg-green-600 rounded-full flex items-center justify-center shadow-2xl shadow-green-500/50 hover:scale-110 transition-all duration-300 group"
    title="Chat on WhatsApp"
  >
    <MessageCircle className="text-white" size={28} />
    <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full animate-pulse"></span>
  </a>
);

// =========================================================================
// III. PAGE COMPONENTS (MOVED OUTSIDE APP)
// =========================================================================

// 🐛 FIXED: Added setSelectedProduct as a prop for the Carousel
const Home = ({
  setPage,
  setShowCatalogModal,
  setSelectedProduct,
  carouselIndex,
  setCarouselIndex,
  prevSlide,
  nextSlide
}) => {
  const slides = [
    "/hero/hero-1.jpg",
    "/hero/hero-2.png",
    "/hero/hero-3.png",
    "/hero/hero-4.jpg",
    "/hero/hero-5.jpg",
    "/hero/hero-6.jpg",
    "/hero/hero-7.jpg",
    "/hero/hero-8.png",
    "/hero/hero-9.avif"
  ];

  const [activeSlide, setActiveSlide] = React.useState(0);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % slides.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="min-h-screen">

      {/* ================= HERO ================= */}
     <section className="relative min-h-[100svh] md:min-h-screen flex items-center bg-gray-900 overflow-hidden pt-24 md:pt-0">
<div className="absolute inset-0 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900" />

        <div className="relative z-10 max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-16 items-center">

          {/* LEFT — TEXT (UNCHANGED STYLE) */}
         <div>
  <div className="inline-block mb-6 px-4 py-2 bg-emerald-500/10 border border-emerald-500/30 rounded-full">
    <span className="text-emerald-400 text-sm font-medium">
      🏆 Industry Leading Quality
    </span>
  </div>

  <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
Premium Cable{" "}
              <span className="bg-gradient-to-r from-emerald-400 to-cyan-400 bg-clip-text text-transparent">
                Management
              </span>{" "}
              Solutions
            </h1>

            <p className="text-xl text-gray-400 mb-10 max-w-xl">
              Industrial-grade cable ties, straps, and accessories trusted by
              professionals worldwide. Built to last, designed to perform.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={() => setPage("products")}
                className="px-8 py-4 bg-gradient-to-r from-emerald-500 to-cyan-500 rounded-xl font-semibold text-white shadow-xl hover:-translate-y-1 transition-all"
              >
                Explore Products
              </button>

              <button
                onClick={() => setShowCatalogModal(true)}
                className="px-8 py-4 bg-white/5 border border-white/20 rounded-xl font-semibold text-white hover:bg-white/10 transition-all"
              >
                Download Catalog
              </button>
            </div>
          </div>

          {/* RIGHT — IMAGE SLIDESHOW */}
          <div className="relative w-full h-[420px] rounded-3xl overflow-hidden border border-gray-700 shadow-2xl">
            {slides.map((src, index) => (
              <img
                key={index}
                src={src}
                alt="Industrial Cable Tie Usage"
                className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ${
                  index === activeSlide ? "opacity-100" : "opacity-0"
                }`}
              />
            ))}

            {/* overlay */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent" />

            {/* dots */}
            <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
              {slides.map((_, i) => (
                <div
                  key={i}
                  className={`w-2 h-2 rounded-full ${
                    i === activeSlide
                      ? "bg-emerald-400 w-6"
                      : "bg-gray-400/50"
                  } transition-all`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>
{/* ================= USE CASES SECTION ================= */}
<section className="py-20 bg-gradient-to-b from-gray-900 to-gray-800 overflow-hidden">
  <div className="max-w-7xl mx-auto px-6">
    <div className="text-center mb-16">
      <span className="text-emerald-400 font-medium text-sm uppercase tracking-wider">
        Trusted Across Industries
      </span>
      <h2 className="text-4xl font-bold text-white mt-3 mb-4">
        Where Our Products Excel
      </h2>
      <p className="text-gray-400 max-w-2xl mx-auto">
        From offshore platforms to food processing facilities, our stainless steel cable ties deliver reliable performance in the most demanding environments
      </p>
    </div>

    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
      {[
        { icon: Factory, title: "Petrochemical Plants", desc: "High-temp resistant" },
        { icon: Ship, title: "Offshore & Marine", desc: "Corrosion proof" },
        { icon: Zap, title: "Power Stations", desc: "Heavy-duty strength" },
        { icon: Utensils, title: "Food Processing Industries", desc: "Hygienic & safe" },
        { icon: Pickaxe, title: "Mining Operations", desc: "Extreme durability" },
        { icon: HardHat, title: "Construction Sites", desc: "Weather resistant" }
      ].map((useCase, i) => (
        <div key={i} className="flex flex-col items-center text-center group">
          <div className="relative mb-4">
            {/* Floating circle with glow effect */}
            <div className="w-24 h-24 bg-gradient-to-br from-emerald-500/20 to-cyan-500/20 rounded-full flex items-center justify-center border-2 border-emerald-500/30 group-hover:border-emerald-500 transition-all duration-500 group-hover:scale-110 group-hover:shadow-2xl group-hover:shadow-emerald-500/50 relative">
              
              {/* Animated background pulse */}
              <div className="absolute inset-0 rounded-full bg-gradient-to-br from-emerald-500/10 to-cyan-500/10 animate-pulse"></div>
              
              {/* ICON */}
              <useCase.icon className="w-10 h-10 text-white relative z-10 group-hover:scale-125 transition-transform duration-300" />
            </div>

            {/* Orbital ring effect */}
            <div className="absolute inset-0 rounded-full border-2 border-dashed border-emerald-500/20 group-hover:rotate-180 transition-transform duration-[3s] pointer-events-none"></div>
          </div>

          <h3 className="text-white font-semibold text-sm mb-1 group-hover:text-emerald-400 transition-colors">
            {useCase.title}
          </h3>
          <p className="text-gray-500 text-xs">
            {useCase.desc}
          </p>
        </div>
      ))}
    </div>

    {/* Optional: Stats bar below use cases */}
    <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6">
      {[
        { value: "-60°C to +300°C", label: "Temperature Range" },
        { value: "SS316", label: "Marine Grade Steel" },
        { value: "450+ lbs", label: "Max Tensile Strength" },
        { value: "20+ Years", label: "Industry Experience" }
      ].map((stat, i) => (
        <div key={i} className="text-center p-4 bg-gray-900/50 rounded-xl border border-gray-700/50">
          <div className="text-2xl font-bold text-emerald-400 mb-1">
            {stat.value}
          </div>
          <div className="text-gray-400 text-sm">
            {stat.label}
          </div>
        </div>
      ))}
    </div>
  </div>
</section>



      {/* ================= FEATURED PRODUCTS (UNCHANGED) ================= */}
      <section className="py-24 bg-gray-900">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-white mb-2">
              Featured Products
            </h2>
            <p className="text-gray-400">
              Our best-selling cable management solutions
            </p>
          </div>

          <Carousel
            items={products.slice(0, 6)}
            setCarouselIndex={setCarouselIndex}
            prevSlide={prevSlide}
            nextSlide={nextSlide}
            carouselIndex={carouselIndex}
            setSelectedProduct={setSelectedProduct}
          />

          <div className="text-center mt-10">
            <button
              onClick={() => setPage("products")}
              className="inline-flex items-center gap-2 text-emerald-400 hover:text-emerald-300 transition-colors font-medium"
            >
              View All Products <ChevronRight size={20} />
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};



const About = () => (
  <div className="min-h-screen pt-24 bg-gray-900">
    <section className="py-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div>
            <span className="text-emerald-400 font-medium">About Max Cable Ties</span>
            <h1 className="text-5xl font-bold text-white mt-2 mb-6">SERVING ITS VALUABLE CUSTOMERS SINCE 1998</h1>
            <p className="text-gray-400 text-lg mb-6">We are the prominent manufacturer and supplier of Coated and Uncoated SS Ball Lock Cable Ties, SS Ladder Cable Ties, SS Releasable Cable Ties, SS Bands, SS Markers and Tags.leader in manufacturing of heavy duty tensioning and cutting tool.</p>
            <p className="text-gray-400 text-lg mb-6">We are manufacturing all these products since 1998 under the team of highly qualified professionals.
We have a production unit equipped with high precision machine tools that deliver products with international standards.
We are committed to the fast, accurate, valued and ethical work method.
By making continuous effort to deepen technology, we make great efforts to meet and to go beyond the customers’ expectations.</p>
           <ul className="list-disc list-inside text-gray-400 text-lg space-y-2"> Why choose us?
  <li>Experience in quality management systems.</li>
  <li>Team of highly skilled engineers.</li>
  <li>Assured quality and quantity at low cost.</li>
  <li>Strict quality control and inspection system.</li>
  <li>Advanced load testing systems.</li>
  <li>Timely and reliable delivery.</li>
  <li>Product tryout available before dispatch.</li>
</ul>

            
            

          </div>
          <div className="relative">
<div className="aspect-square bg-gradient-to-br from-emerald-500/20 to-cyan-500/20 rounded-3xl flex items-center justify-center overflow-hidden">
  <img
    src="/logo.png"
    alt="Max Cable Ties Logo"
    className="w-full h-full object-contain"
  />
</div>


            <div className="absolute -bottom-6 -left-6 p-6 bg-gray-800 border border-gray-700 rounded-2xl">
              <div className="text-3xl font-bold text-emerald-400">20+</div>
              <div className="text-gray-400">Years of Excellence</div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="py-20 bg-gray-800">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl font-bold text-white text-center mb-16">Our Values</h2>
        <div className="grid md:grid-cols-3 gap-8">
          {[
            { title: 'Quality First', desc: 'Every product meets the highest international standards before reaching our customers.', icon: '🎯' },
            { title: 'Innovation', desc: 'Continuously developing new solutions to meet evolving industry demands.', icon: '💡' },
            { title: 'Sustainability', desc: 'Committed to eco-friendly manufacturing and recyclable materials.', icon: '🌱' },
          ].map((v, i) => (
            <div key={i} className="p-8 bg-gray-900 rounded-2xl border border-gray-700 hover:border-emerald-500/50 transition-all duration-300 group hover:-translate-y-2">
              <div className="text-5xl mb-6">{v.icon}</div>
              <h3 className="text-xl font-semibold text-white mb-3">{v.title}</h3>
              <p className="text-gray-400">{v.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  </div>
);

const Products = ({ 
  selectedCategory, 
  setSelectedCategory, 
  filteredProducts, 
  setCarouselIndex, 
  nextSlide, 
  prevSlide, 
  carouselIndex,
  setSelectedProduct 
}) => {
  const categories = ['All', ...new Set(products.map(p => p.category))];

  return (
    <div className="min-h-screen pt-24 bg-gray-900">
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6">
          
          <div className="text-center mb-12">
            <h1 className="text-5xl font-bold text-white mb-4">Our Products</h1>
            <p className="text-gray-400 text-lg max-w-2xl mx-auto">
              Discover our comprehensive range of cable management solutions
            </p>
          </div>

          {/* Categories */}
          <div className="flex flex-wrap justify-center gap-3 mb-12">
            {categories.map(c => (
              <button 
                key={c} 
                onClick={() => setSelectedCategory(c)} 
                className={`px-6 py-3 rounded-xl font-medium transition-all duration-300 ${
                  selectedCategory === c 
                    ? 'bg-gradient-to-r from-emerald-500 to-cyan-500 text-white shadow-lg shadow-emerald-500/30' 
                    : 'bg-gray-800 text-gray-300 hover:bg-gray-700'
                }`}
              >
                {c}
              </button>
            ))}
          </div>

          {/* PRODUCTS */}
          <div className="relative">
            <div className="overflow-hidden">
              <div
                className="flex gap-6 transition-transform duration-500 ease-out flex-col md:flex-row"
                style={{
                  transform: window.innerWidth >= 768
                    ? `translateX(-${carouselIndex * 288}px)`
                    : "none"
                }}
              >
                {filteredProducts.map(p => (
                  <ProductCard 
                    key={p.id} 
                    p={p} 
                    onClick={setSelectedProduct} 
                  />
                ))}
              </div>
            </div>

            {/* Desktop arrows only */}
            {filteredProducts.length > 3 && (
              <div className="hidden md:block">
                <button 
                  onClick={prevSlide} 
                  className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 w-12 h-12 bg-gray-800 border border-gray-700 rounded-full flex items-center justify-center text-white hover:bg-emerald-500 hover:border-emerald-500 transition-all shadow-xl z-10"
                >
                  <ChevronLeft size={24} />
                </button>

                <button 
                  onClick={nextSlide} 
                  className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 w-12 h-12 bg-gray-800 border border-gray-700 rounded-full flex items-center justify-center text-white hover:bg-emerald-500 hover:border-emerald-500 transition-all shadow-xl z-10"
                >
                  <ChevronRight size={24} />
                </button>
              </div>
            )}

            {/* Desktop dots only */}
            <div className="hidden md:flex justify-center gap-2 mt-8">
              {Array.from({ length: Math.max(1, filteredProducts.length - 2) }).map((_, i) => (
                <button 
                  key={i} 
                  onClick={() => setCarouselIndex(i)} 
                  className={`w-2 h-2 rounded-full transition-all ${
                    i === carouselIndex 
                      ? 'w-8 bg-emerald-500' 
                      : 'bg-gray-600 hover:bg-gray-500'
                  }`} 
                />
              ))}
            </div>
          </div>

        </div>
      </section>
    </div>
  );
};


const Contact = ({ formData, handleFormChange, submitted, setSubmitted }) => {

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { name, email, message } = formData;

    // Frontend validation
    if (!name.trim()) {
      alert("Please enter your full name.");
      return;
    }

    if (!email.trim()) {
      alert("Please enter your email address.");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      alert("Please enter a valid email address.");
      return;
    }

    if (!message.trim()) {
      alert("Please enter your message.");
      return;
    }

    try {
      const response = await fetch("https://maxcableties.com/contact.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          name,
          email,
          message,
        }),
      });

      const result = await response.json();

      if (result.status === "success") {
        setSubmitted(true);
      } else {
        alert("Message failed to send. Please try again.");
      }
    } catch (error) {
      console.error(error);
      alert("Server error. Please try again later.");
    }
  };

  return (
    <div className="min-h-screen pt-24 bg-gray-900">
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-16">

            {/* LEFT INFO */}
            <div>
              <span className="text-emerald-400 font-medium">Get In Touch</span>
              <h1 className="text-5xl font-bold text-white mt-2 mb-6">
                Let's Work Together
              </h1>
              <p className="text-gray-400 text-lg mb-10">
                Have questions about our products? Need a custom quote? We're here to help.
              </p>

              <div className="space-y-6">
                {[
                  { icon: Phone, label: "Phone", value: "+91 8401452740" },
                  { icon: Mail, label: "Email", value: "micratools@gmail.com" },
                  {
                    icon: MapPin,
                    label: "Address",
                    value:
                      "D-10, Road No. 2, Sardar Industrial Estate, Ajwa Road, Vadodara, Gujarat",
                  },
                ].map((c, i) => (
                  <div key={i} className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-emerald-500/20 rounded-xl flex items-center justify-center">
                      <c.icon className="text-emerald-400" size={20} />
                    </div>
                    <div>
                      <div className="text-gray-400 text-sm">{c.label}</div>
                      <div className="text-white font-medium">{c.value}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* RIGHT FORM */}
            <div className="bg-gray-800 rounded-3xl p-8 border border-gray-700">
              {submitted ? (
                <div className="h-full flex flex-col items-center justify-center text-center">
                  <div className="w-20 h-20 bg-emerald-500/20 rounded-full flex items-center justify-center mb-6">
                    <CheckCircle className="text-emerald-400" size={40} />
                  </div>
                  <h3 className="text-2xl font-bold text-white mb-2">
                    Message Sent!
                  </h3>
                  <p className="text-gray-400">
                    We'll get back to you shortly.
                  </p>
                </div>
              ) : (
                <>
                  <h2 className="text-2xl font-bold text-white mb-6">
                    Send us a Message
                  </h2>

                  <form onSubmit={handleSubmit}>
                    <div className="space-y-6">
                      <div>
                        <label className="text-gray-300 text-sm mb-2 block">
                          Full Name
                        </label>
                        <input
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={handleFormChange}
                          className="w-full px-4 py-3 bg-gray-900 border border-gray-700 rounded-xl text-white focus:border-emerald-500 focus:outline-none"
                          placeholder="Enter your full name"
                        />
                      </div>

                      <div>
                        <label className="text-gray-300 text-sm mb-2 block">
                          Email Address
                        </label>
                        <input
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleFormChange}
                          className="w-full px-4 py-3 bg-gray-900 border border-gray-700 rounded-xl text-white focus:border-emerald-500 focus:outline-none"
                          placeholder="abc@company.com"
                        />
                      </div>

                      <div>
                        <label className="text-gray-300 text-sm mb-2 block">
                          Message
                        </label>
                        <textarea
                          name="message"
                          value={formData.message}
                          onChange={handleFormChange}
                          rows={4}
                          className="w-full px-4 py-3 bg-gray-900 border border-gray-700 rounded-xl text-white focus:border-emerald-500 focus:outline-none resize-none"
                          placeholder="Tell us about your requirements..."
                        />
                      </div>

                      <button
                        type="submit"
                        className="w-full py-4 bg-gradient-to-r from-emerald-500 to-cyan-500 rounded-xl font-semibold text-white shadow-lg hover:-translate-y-1 transition-all"
                      >
                        Send Message
                      </button>
                    </div>
                  </form>
                </>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};


const Footer = ({ setPage, setShowCatalogModal }) => (
  <footer className="bg-gray-950 border-t border-gray-800 py-12">
    <div className="max-w-7xl mx-auto px-6">
      {/* Main Footer Content */}
      <div className="grid md:grid-cols-4 gap-8 mb-8">
        {/* Company Info */}
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <img 
              src="/MEW logo.png"
              alt="Company Logo"
              className="w-20 h-20 object-contain"
            />
            <span className="text-3xl font-bold text-white">Max Cable Ties</span>
          </div>
          <p className="text-gray-400 mb-4 max-w-md">
            Premium cable management solutions trusted by professionals worldwide. Built to last, designed to perform.
          </p>
          <button 
            onClick={() => setShowCatalogModal(true)}
            className="px-6 py-3 bg-gradient-to-r from-emerald-500 to-cyan-500 rounded-xl font-semibold text-white hover:shadow-lg hover:shadow-emerald-500/30 transition-all duration-300 flex items-center gap-2"
          >
            <Download size={18} /> Download Catalog
          </button>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-white font-semibold mb-4">Quick Links</h3>
          <div className="space-y-2">
            {['Home', 'About', 'Products', 'Contact'].map(l => (
              <button 
                key={l} 
                onClick={() => setPage(l.toLowerCase())} 
                className="block text-gray-400 hover:text-emerald-400 transition-colors"
              >
                {l}
              </button>
            ))}
          </div>
        </div>

        {/* Contact Info */}
        <div>
          <h3 className="text-white font-semibold mb-4">Contact Us</h3>
          <div className="space-y-3">
            <div className="flex items-start gap-2 text-gray-400 text-sm">
              <Phone size={16} className="text-emerald-400 mt-1 flex-shrink-0" />
              <span>+91 8401452740</span>
            </div>
            <div className="flex items-start gap-2 text-gray-400 text-sm">
              <Mail size={16} className="text-emerald-400 mt-1 flex-shrink-0" />
              <span>micratools@gmail.com</span> 
            </div>
            <div className="flex items-start gap-2 text-gray-400 text-sm">
              <MapPin size={16} className="text-emerald-400 mt-1 flex-shrink-0" />
              <span>D-10, Road No. 2, Sardar Industrial Estate, Ajwa Road, Vadodara, Gujarat</span>
            </div>
          </div>
        </div>
      </div>

      {/* Google Maps Section */}
<div className="border-t border-gray-800 pt-8 mb-8">
  <h3 className="text-white font-semibold mb-4 text-center flex items-center justify-center gap-2">
    <MapPin className="text-emerald-400" size={20} />
    Visit Our Factory
  </h3>
  
  
    <a href="https://www.google.com/maps/dir//D-10,+Road+No.+2,+Sardar+Industrial+Estate,+Ajwa+Road,+Vadodara,+Gujarat"
    target="_blank"
    rel="noopener noreferrer"
    className="block relative rounded-xl overflow-hidden border-2 border-gray-700 hover:border-emerald-500 shadow-lg max-w-4xl mx-auto group cursor-pointer transition-all"
  >
    <div className="relative h-64">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d13363.020169718064!2d73.21755685!3d22.29107415!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x395fcfc7ba54ff05%3A0xe0626315183c58d1!2sD-10%2C%20Rd%20Number%202%2C%20Sardar%20Estate%2C%20Sayaji%20Park%20Society%2C%20Vadodara%2C%20Gujarat%20390019!3m2!1d22.313816499999998!2d73.23543149999999!5e1!3m2!1sen!2sin!4v1766912075952!5m2!1sen!2sin"
        width="100%"
        height="100%"
        style={{ border: 0, pointerEvents: 'none' }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Max Cable Ties Location"
      ></iframe>
      
      {/* Click overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent group-hover:from-black/80 transition-all flex items-end justify-center pb-6">
        <div className="text-center bg-emerald-500 px-6 py-3 rounded-full group-hover:scale-110 transition-transform shadow-lg">
          <p className="text-white font-semibold flex items-center gap-2">
            <MapPin size={20} />
            Open in Google Maps
          </p>
        </div>
      </div>
    </div>
  </a>
  
  <p className="text-center text-gray-400 text-sm mt-3">
    D-10, Road No. 2, Sardar Industrial Estate, Ajwa Road, Vadodara, Gujarat
  </p>
</div>
      {/* Bottom Bar */}
      <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center gap-4">
        <p className="text-gray-500 text-sm">© 2025 Max Cable Ties. All rights reserved.</p>
      </div>
    </div>
  </footer>
);


// =========================================================================
// IV. MAIN APP COMPONENT (CONTROLLER)
// =========================================================================

export default function App() {
  const [page, setPage] = useState('home');
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [carouselIndex, setCarouselIndex] = useState(0);
  const [showCatalogModal, setShowCatalogModal] = useState(false);

  // Scroll effect for header
  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Reset carousel index when category changes
  useEffect(() => { setCarouselIndex(0); }, [selectedCategory]);
  
useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [page]);

  // Stable handler function for form changes
  const handleFormChange = (e) => {
    const {name, value} = e.target;
    setFormData(prev => ({ ...prev, [name]: value}));
  };
  
  // Product filtering and carousel logic
  const filteredProducts = selectedCategory === 'All' ? products : products.filter(p => p.category === selectedCategory);
  
  const nextSlide = () => setCarouselIndex(i => (i + 1) % Math.max(1, filteredProducts.length - 2));
  const prevSlide = () => setCarouselIndex(i => (i - 1 + Math.max(1, filteredProducts.length - 2)) % Math.max(1, filteredProducts.length - 2));

  // Determine which page component to render
  const renderPage = () => {
    switch (page) {
     case 'home':
  return (
    <Home 
      setPage={setPage}
      setShowCatalogModal={setShowCatalogModal}
      setSelectedProduct={setSelectedProduct}

      carouselIndex={carouselIndex}
      setCarouselIndex={setCarouselIndex}
      prevSlide={prevSlide}
      nextSlide={nextSlide}
    />
  );

      case 'about':
        return <About />;
      case 'products':
        return (
          <Products 
            selectedCategory={selectedCategory} 
            setSelectedCategory={setSelectedCategory} 
            filteredProducts={filteredProducts} 
            setCarouselIndex={setCarouselIndex} 
            nextSlide={nextSlide} 
            prevSlide={prevSlide} 
            carouselIndex={carouselIndex}
            setSelectedProduct={setSelectedProduct} // 🐛 PROP PASSED HERE
          />
        );
      case 'contact':
        return (
          <Contact 
            formData={formData} 
            handleFormChange={handleFormChange} 
            submitted={submitted} 
            setSubmitted={setSubmitted} 
          />
        );
      default:
        // 🐛 FIX APPLIED: Passing setSelectedProduct
        return <Home setPage={setPage} setShowCatalogModal={setShowCatalogModal} setSelectedProduct={setSelectedProduct} />;
    }
  };

  return (
    <div className="bg-gray-900 min-h-screen">
      <Header 
        scrollY={scrollY} 
        page={page} 
        setPage={setPage} 
        menuOpen={menuOpen} 
        setMenuOpen={setMenuOpen} 
      />
      {renderPage()}
      
      {/* Modals are rendered conditionally outside of the main page flow */}
      {selectedProduct && (
  <SpecsModal 
    product={selectedProduct} 
    onClose={() => setSelectedProduct(null)} 
    setPage={setPage}   // ✅ SEND NAVIGATION DOWN
  />
)}
   {showCatalogModal && <CatalogModal setShowCatalogModal={setShowCatalogModal} />}
      
      <WhatsAppButton />
      <Footer setPage={setPage} setShowCatalogModal={setShowCatalogModal} />
    </div>
  );
}
